import NextLink, { type LinkProps } from 'next/link'
import { forwardRef } from 'react'

 
export type DynamicLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> &
  Omit<LinkProps, 'href'> & { href: string }

const Link = forwardRef<HTMLAnchorElement, DynamicLinkProps>(function Link({ ...props }, ref) {
  return <NextLink ref={ref} {...props} />
})
export default Link
